// extracted by mini-css-extract-plugin
export var disabledOption = "_5g-1";
export var dropdownItemWrapper = "_5g-0";